import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import Brand from "../components/Brand";

export default function ManagerLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { saveSession } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      saveSession(data);
      toast.success(`Welcome back, ${data.user.name}`);
      navigate("/manager");
    } catch (err) {
      toast.error(formatApiError(err, "Login failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Manager Login" subtitle="Email & password">
      <form onSubmit={submit} className="space-y-4" data-testid="manager-login-form">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          data-testid="manager-login-email-input"
          className="w-full h-12 px-4 rounded-xl bg-[#FAF6F0] border border-[#E4DDD3] text-[#1A1D20] placeholder-slate-400 focus:outline-none focus:border-terra-400/60"
        />
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          data-testid="manager-login-password-input"
          className="w-full h-12 px-4 rounded-xl bg-[#FAF6F0] border border-[#E4DDD3] text-[#1A1D20] placeholder-slate-400 focus:outline-none focus:border-terra-400/60"
        />
        <button
          type="submit"
          disabled={busy}
          data-testid="manager-login-submit-button"
          className="w-full h-12 rounded-xl bg-terra-500 text-white font-display font-bold text-lg hover:bg-terra-600 disabled:opacity-50 transition-colors"
        >
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
      <div className="mt-4 text-sm text-slate-500 text-center">
        <Link to="/forgot-password" className="text-terra-600 hover:underline" data-testid="forgot-password-link">
          Forgot your password?
        </Link>
      </div>
      <div className="mt-3 text-sm text-slate-500 text-center">
        No business yet?{" "}
        <Link to="/create-restaurant" className="text-terra-600 hover:underline" data-testid="goto-create-restaurant-link">
          Create one
        </Link>
      </div>
    </AuthShell>
  );
}

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-[#FBF8F3] flex flex-col items-center justify-center px-4 py-10">
      <Link to="/" className="flex items-center gap-2 mb-8" data-testid="auth-brand-link">
        <Brand size="text-xl" iconClass="h-10 w-10" />
      </Link>
      <div className="w-full max-w-md p-6 sm:p-8 rounded-2xl bg-white border border-[#E4DDD3]">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#1A1D20]">{title}</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">{subtitle}</p>
        {children}
      </div>
    </div>
  );
}
